import React, { Component } from "react";
import "../css/App.css";

class AssignedModulesChild1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }
  componentWillMount() {}

  render() {
    return (
      <div
        className="unit_assign col-sm-12"
        onClick={() => this.props.starUnit()}
        style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}
      >
        <div
          className="col-sm-10 col-xs-10 pad_z"
          style={{
            fontSize: "13px",
            fontWeight: "500",
            textTransform: "capitalize",
          }}
        >
          {this.props.ChildComponent1content}
        </div>

        {/* Completion Status Tick Icon */}
        <div className="col-sm-1 col-xs-1 pad_z" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          {this.props.greenDot && (
            <div
              style={{
                width: 16,
                height: 16,
                borderRadius: "50%",
                backgroundColor: this.props.greenDot || "#7ed321",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 1px 2px rgba(0,0,0,0.2)"
              }}
            >
              <i
                className="material-icons"
                style={{
                  color: "white",
                  fontSize: "10px",
                  fontWeight: "bold"
                }}
              >
                check
              </i>
            </div>
          )}
        </div>

        <div className="col-sm-1 col-xs-1 pad_z">
          <i className="material-icons">keyboard_arrow_right</i>
        </div>
      </div>
    );
  }
}

export default AssignedModulesChild1;
